import { Link } from "react-router-dom";

const linkGroups = [
  {
    title: "浏览内容",
    links: [
      { to: "/", label: "首页" },
      { to: "/news", label: "动漫资讯" },
      { to: "/anime", label: "动漫作品" },
      { to: "/search", label: "搜索" },
    ],
  },
  {
    title: "关于 h动漫",
    links: [
      { to: "/about", label: "关于我们" },
      { to: "/contact", label: "联系我们" },
    ],
  },
];

const socials = [
  { icon: "ri-weibo-fill", label: "微博", href: "https://theoutlook.asia" },
  { icon: "ri-bilibili-fill", label: "哔哩哔哩", href: "https://www.bilibili.com" },
  { icon: "ri-wechat-fill", label: "微信", href: "https://weixin.qq.com" },
  { icon: "ri-rss-fill", label: "RSS 订阅", href: "#" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading font-extrabold text-lg">
                h
              </span>
              <span className="font-heading font-extrabold text-lg text-background-50">h动漫</span>
            </div>
            <p className="mt-4 text-sm text-background-300 leading-relaxed max-w-md">
              h动漫是面向二次元爱好者的动漫资讯与作品推荐平台，为你带来最新动漫新闻、作品资料与深度评论分析。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  title={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer text-background-50"
                >
                  <i className={s.icon} />
                </a>
              ))}
            </div>
          </div>

          {linkGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading font-semibold text-background-50 text-sm">{group.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 h动漫 hanime.example.com 保留所有权利</p>
          <p>本站内容为演示用途，所有资讯与作品数据均为示例。</p>
        </div>
      </div>
    </footer>
  );
}